export const WEBSITE_URL = process.env.REACT_APP_WEBSITE_URL || 'https://torbet.com';
export const DESKTOP_APP_DOWNLOAD_URL = process.env.REACT_APP_DESKTOP_APP_DOWNLOAD_URL || 'https://shorturl.at/JSVZ9';

export const SESSION_RESOURCE_LINKS = [
  WEBSITE_URL,
  'https://perla-tech.com',
  'https://shamcoders.com',
  'https://google.com',
];
